import { render, staticRenderFns } from "./Search2.vue?vue&type=template&id=f0970092&scoped=true&"
import script from "./Search2.vue?vue&type=script&lang=js&"
export * from "./Search2.vue?vue&type=script&lang=js&"
import style0 from "./Search2.vue?vue&type=style&index=0&id=f0970092&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0970092",
  null
  
)

export default component.exports